import { useQuery } from '@tanstack/react-query';
import { getPropertyReportedFindings, getReportedFindings, getUrgentReportedFindings } from '../service';
import { ReportedFindingsFilter } from '../types/filters';

function useReportedFindings(
    filters: ReportedFindingsFilter,
    pageNumber: number,
    pageSize: number
) {
    const query = useQuery({
        queryKey: ['reported-findings', filters, pageNumber, pageSize],
        queryFn: () => getReportedFindings({ ...filters }, pageNumber, pageSize),
    });

    return query;
}

function usePropertyReportedFindings(
    propertyId: number
) {
    const query = useQuery({
        queryKey: ['property', propertyId, 'reported-findings'],
        queryFn: () => getPropertyReportedFindings(propertyId),
    });

    return query;
}

function useUrgentReportedFindings(
    propertyManagerId?: string
) {
    const query = useQuery({
        queryKey: ['dashboard', 'tab', 'urgent-reported-findings', propertyManagerId],
        queryFn: () => getUrgentReportedFindings(propertyManagerId),
    });

    return query;
}

export { useReportedFindings, usePropertyReportedFindings, useUrgentReportedFindings };
